import React from 'react';
import { Layers, CircleCheck, Package } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';

export default function SegmentAnalytics({ storeTypes }) {
    const analytics = React.useMemo(() => {
        const totalSegments = storeTypes?.length || 0;
        const activeSegments = storeTypes?.filter((s) => s.active)?.length || 0;

        // Count by channel
        const moderno = storeTypes?.filter((s) => s.channel === 'moderno')?.length || 0;
        const tradicional = storeTypes?.filter((s) => s.channel === 'tradicional')?.length || 0;

        // Total products across all segments
        const totalProducts = storeTypes?.reduce((sum, s) => sum + (s.products?.length || 0), 0) || 0;

        return { totalSegments, activeSegments, moderno, tradicional, totalProducts };
    }, [storeTypes]);

    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            <StatCard
                label="Total Segmentaciones"
                value={formatNumber(analytics.totalSegments)}
                icon={<Layers />}
                tone="brand"
                hint={`${analytics.moderno} moderno · ${analytics.tradicional} tradicional`}
            />
            <StatCard
                label="Segmentaciones Activas"
                value={formatNumber(analytics.activeSegments)}
                icon={<CircleCheck />}
                tone="success"
                hint="En uso actualmente"
            />
            <StatCard
                label="Total Productos"
                value={formatNumber(analytics.totalProducts)}
                icon={<Package />}
                tone="violet"
                hint="Configurados en segmentos"
            />
        </div>
    );
}
